/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import Box from '@mui/material/Box';
import { shallowEqual, useSelector } from 'react-redux';
import { selectPlatformListItemsUnfiltered, TerminalListItem } from '../../store';
import AutocompleteSelect from '../common/selects/AutocompleteSelect';
import { EMPTY_FIELD_STRING_PLACEHOLDER } from '../../utils/StringUtils';
export interface DataUsageTerminalSelectorProps {
  onSelectboxValueChanged: (values: TerminalListItem[]) => void;
}
function DataUsageTerminalSelector({ onSelectboxValueChanged }: DataUsageTerminalSelectorProps) {
  const terminals = useSelector(selectPlatformListItemsUnfiltered, shallowEqual);

  return (
    <Box sx={{ width: '358px', position: 'relative' }}>
      <AutocompleteSelect<TerminalListItem>
        onSelectboxValueChanged={(values: TerminalListItem[]) => {
          onSelectboxValueChanged(values);
        }}
        getOptionLabel={(terminal: TerminalListItem) =>
          terminal.terminalDisplayName ? terminal.terminalDisplayName : EMPTY_FIELD_STRING_PLACEHOLDER
        }
        isOptionEqualToValue={(option: TerminalListItem, val: TerminalListItem) => {
          return option.datapathUuid === val.datapathUuid;
        }}
        options={terminals}
        placeholderText="Select terminal(s)"
        multipleSelectedText="Multiple terminals selected"
      />
    </Box>
  );
}

export default DataUsageTerminalSelector;
